import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RootComponent } from './root/root.component';
import { SearchComponent} from './search/search.component';
import { BroverRouterModule} from '../brover-router/brover.router.module';
import { BroverMaterialModule} from '../brover-material/brover.material.module';
import { BrowserModule} from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MatMenuModule as MatMenuModule} from '@angular/material/menu';

@NgModule({
  declarations: [
    SearchComponent,
    RootComponent
  ],
  imports: [
    CommonModule,
    BroverRouterModule,
    BroverMaterialModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    SearchComponent
  ]
})
export class BroverDefaultComponentModule { }
